module.exports = __webpack_public_path__ + "static/media/Banner2.934ea180.jpg";